import React from 'react';
import { useOrderRequestOrderRequestStatusInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IOrderRequest } from '../../order-request-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

// Status is always disabled here: the upsert no longer sends it (new requests
// default to id = 1), and only admins can change it via the separate
// "Cambiar status" dialog / updateOrderRequestStatus mutation.
export function OrderRequestStatusInput() {
    const inputName: keyof IOrderRequest = 'order_request_status_id';
    const { data: orderRequestsStatusesData } =
        useOrderRequestOrderRequestStatusInputQuery();

    const orderRequestStatuses =
        orderRequestsStatusesData?.getOrderRequestStatuses || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.order_request_status_id)}
            options={orderRequestStatuses}
            disabled
        />
    );
}
